module.exports = __webpack_public_path__ + "img/attendance.c00e5aff.png";